import Home from './Home';
import Projects from './Projects';
import Blogs from './Blogs';
import Clients from './Clients';
import Certifications from './Certifications';
import Contact from './Contact';
import NotFound from './NotFound';
import Jobs from './Jobs/Jobs';
import JobsAndroid from './Jobs/JobsAndroid';
import JobsIOSSenior from './Jobs/JobsIOSSenior';
import JobsIOSJunior from './Jobs/JobsIOSJunior';
import JobsTester from './Jobs/JobsTester';
import JobsDesigner from './Jobs/JobsDesigner';
import Youll from './Youll';

const jobsStyle = {
  background: {
    backgroundColor: '#fff',
    backgroundImage: 'none'
  },
  header: {
    logo: {
      fill: '#1800FF'
    },
    text: {
      color: 'rgba(0,0,0,0)'
    },
    button: {
      color: 'rgba(0,0,0,0)',
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0)'
    },
    buttonHover: {
      color: 'rgba(0,0,0,0)',
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0)'
    }
  },
  footer: {
    color: '#000'
  },
  scroller: {
    color: 'rgba(0,0,0,0)'
  },
  landscapeOverlay: {
    logo: {
      fill: '#1800FF'
    },
    text: {
      color: '#000'
    }
  }
};

export default [
  {
    key: 'home',
    path: '/',
    exact: true,
    component: Home,
    meta: {
      title: 'Work in Progress: App Design and Development Company',
      description:
        'Over a decade of delivering apps to startups & enterprise. App design & development to the highest standards of iOS and Android. Start building your app today!',
      themeColor: '#1088F1'
    },
    styles: {
      background: {
        backgroundColor: '#3988EA',
        backgroundImage: 'none'
      },
      header: {
        logo: {
          fill: '#fff'
        },
        text: {
          color: '#fff'
        },
        button: {
          color: '#fff',
          borderColor: '#fff',
          backgroundColor: 'rgba(57,136,234,0)'
        },
        buttonHover: {
          color: '#3988EA',
          borderColor: '#fff',
          backgroundColor: '#fff'
        }
      },
      footer: {
        color: '#fff'
      },
      scroller: {
        color: '#fff'
      },
      landscapeOverlay: {
        logo: {
          fill: '#fff'
        },
        text: {
          color: '#fff'
        }
      }
    }
  },
  {
    key: 'clients',
    path: '/clients',
    exact: true,
    component: Clients,
    meta: {
      title:
        'Work in Progress: We’ve helped startups grow and we delivered for world class brands',
      description:
        'Work in Progress has a proven track record of delivering for successful startups like Headspace, What3Words, Zenefits and for world class brands like General Electric, Sony Pictures, Staples, OMV.',
      themeColor: '#1800FF'
    },
    styles: {
      background: {
        backgroundColor: '#fff',
        backgroundImage: 'none'
      },
      header: {
        logo: {
          fill: '#1800FF'
        },
        text: {
          color: '#000'
        },
        button: {
          color: '#1800FF',
          borderColor: '#FFF514',
          backgroundColor: '#FFF514'
        },
        buttonHover: {
          color: '#FFF514',
          borderColor: '#1800FF',
          backgroundColor: '#1800FF'
        }
      },
      footer: {
        color: '#000'
      },
      scroller: {
        color: '#000'
      },
      landscapeOverlay: {
        logo: {
          fill: '#1800FF'
        },
        text: {
          color: '#000'
        }
      }
    }
  },
  {
    key: 'youll',
    path: '/youll',
    exact: true,
    component: Youll,
    meta: {
      title:
        'Youll: No-code iOS and Android Apps to teach others what you know',
      description:
        'Youll is a no-code platform for creating your own iOS and Android Apps to share your knowledge. Created by the engineers behind Headspace.',
      themeColor: '#1088F1'
    },
    styles: {
      background: {
        backgroundColor: '#00323C',
        backgroundImage: 'none'
      },
      header: {
        logo: {
          fill: '#fff'
        },
        text: {
          color: '#fff'
        },
        button: {
          color: '#fff',
          borderColor: '#fff',
          backgroundColor: 'rgba(57,136,234,0)'
        },
        buttonHover: {
          color: '#3988EA',
          borderColor: '#fff',
          backgroundColor: '#fff'
        }
      },
      footer: {
        color: '#fff'
      },
      scroller: {
        color: '#fff'
      },
      landscapeOverlay: {
        logo: {
          fill: '#fff'
        },
        text: {
          color: '#fff'
        }
      }
    }
  },
  {
    key: 'blog',
    path: '/blogs',
    exact: true,
    component: Blogs,
    meta: {
      title:
        'Work in Progress: We’ve helped startups grow and we delivered for world class brands',
      description:
        'Work in Progress has a proven track record of delivering for successful startups like Headspace, What3Words, Zenefits and for world class brands like General Electric, Sony Pictures, Staples, OMV.',
      themeColor: '#FFA198'
    },
    styles: {
      background: {
        backgroundColor: '#140FF2',
        backgroundImage: 'none'
      },
      header: {
        logo: {
          fill: '#FFD100'
        },
        text: {
          color: '#FFC414'
        },
        button: {
          color: '#FFC414',
          borderColor: '#FFC414',
          backgroundColor: '#140FF2'
        },
        buttonHover: {
          color: '#FFF514',
          borderColor: '#1800FF',
          backgroundColor: '#1800FF'
        }
      },
      footer: {
        color: '#FFC414'
      },
      scroller: {
        color: '#FFC414'
      },
      landscapeOverlay: {
        logo: {
          fill: '#1800FF'
        },
        text: {
          color: '#FFC414'
        }
      }
    }
  },
  {
    key: 'projects',
    path: '/projects',
    exact: true,
    component: Projects,
    meta: {
      title: 'Work in Progress: Always delivering some amazing apps',
      description:
        'We took many companies from zero to hundreds of million of dollar valuation. Lets make your story a successful one as well!',
      themeColor: '#FFA198'
    },
    styles: {
      background: {
        backgroundColor: '#6554FF',
        backgroundImage: 'none'
      },
      header: {
        logo: {
          fill: '#FFA0AC'
        },
        text: {
          color: '#FFFB9E'
        },
        button: {
          color: '#FFFB9E',
          borderColor: '#FFFB9E',
          backgroundColor: '#6554FF'
        },
        buttonHover: {
          color: '#6554FF',
          borderColor: '#FFFB9E',
          backgroundColor: '#FFFB9E'
        }
      },
      footer: {
        color: '#FFFB9E'
      },
      scroller: {
        color: '#fff'
      },
      landscapeOverlay: {
        logo: {
          fill: '#FFA0AC'
        },
        text: {
          color: '#FFFB9E'
        }
      }
    }
  },
  {
    key: 'awards',
    path: '/awards',
    exact: true,
    component: Certifications,
    meta: {
      title: 'Work in Progress: Google Certified Agency',
      description:
        'We take pride in our awards and certifications, over the years we have been nominated and won many awards. Now Work in Progress is one of the only 50 Google Certified Agencies.',
      themeColor: '#0090B4'
    },
    styles: {
      background: {
        backgroundColor: '#0090B4',
        backgroundImage: 'none'
      },
      header: {
        logo: {
          fill: '#FFA198'
        },
        text: {
          color: '#004D60'
        },
        button: {
          color: '#FFA198',
          borderColor: '#FFA198',
          backgroundColor: '#0090B4'
        },
        buttonHover: {
          color: '#0090B4',
          borderColor: '#FFA198',
          backgroundColor: '#FFA198'
        }
      },
      footer: {
        color: '#004D60'
      },
      scroller: {
        color: '#fff'
      },
      landscapeOverlay: {
        logo: {
          fill: '#FFA198'
        },
        text: {
          color: '#004D60'
        }
      }
    }
  },
  {
    key: 'contact',
    path: '/contact',
    exact: true,
    component: Contact,
    meta: {
      title: 'Work in Progress: Global app delivery from Cluj-Napoca',
      description:
        'We work with clients across the globe, from LA to London to Sydney, but you will always find us in Transylvania, in Cluj-Napoca, Romania. Start building your app today!',
      themeColor: '#1B1B1B'
    },
    styles: {
      background: {
        backgroundColor: '#1B1B1B'
      },
      header: {
        logo: {
          fill: '#fff'
        },
        text: {
          color: 'rgba(0,0,0,0)'
        },
        button: {
          color: 'rgba(0,0,0,0)',
          borderColor: 'rgba(0,0,0,0)',
          backgroundColor: 'rgba(0,0,0,0)'
        },
        buttonHover: {
          color: 'rgba(0,0,0,0)',
          borderColor: 'rgba(0,0,0,0)',
          backgroundColor: 'rgba(0,0,0,0)'
        }
      },
      footer: {
        color: '#fff'
      },
      scroller: {
        color: 'rgba(0,0,0,0)'
      },
      landscapeOverlay: {
        logo: {
          fill: '#fff'
        },
        text: {
          color: '#fff'
        }
      }
    }
  },
  {
    key: 'jobs',
    path: '/jobs',
    component: Jobs,
    standalone: true,
    exact: true,
    meta: {
      title: 'Work in Progress: Available Positions',
      description:
        'Life is short, work somewhere awesome! Join our team in Cluj-Napoca.',
      themeColor: '#1800FF'
    },
    styles: jobsStyle
  },
  {
    key: 'jobsAndroid',
    path: '/jobs/android',
    component: JobsAndroid,
    standalone: true,
    exact: true,
    meta: {
      title: 'Work in Progress: Hiring Android Developer',
      description:
        'Life is short, work somewhere awesome! We’re now hiring Android developers in Cluj-Napoca.',
      themeColor: '#1800FF'
    },
    styles: jobsStyle
  },
  {
    key: 'jobsIOS',
    path: '/jobs/ios-junior',
    component: JobsIOSJunior,
    standalone: true,
    exact: true,
    meta: {
      title: 'Work in Progress: Hiring iOS Developer',
      description:
        'Life is short, work somewhere awesome! We’re now hiring iOS developers in Cluj-Napoca.',
      themeColor: '#1800FF'
    },
    styles: jobsStyle
  },
  {
    key: 'jobsIOS',
    path: '/jobs/ios-senior',
    component: JobsIOSSenior,
    standalone: true,
    exact: true,
    meta: {
      title: 'Work in Progress: Hiring iOS Developer',
      description:
        'Life is short, work somewhere awesome! We’re now hiring iOS developers in Cluj-Napoca.',
      themeColor: '#1800FF'
    },
    styles: jobsStyle
  },
  {
    key: 'jobsTester',
    path: '/jobs/tester',
    component: JobsTester,
    standalone: true,
    exact: true,
    meta: {
      title: 'Work in Progress: Hiring Manual Tester',
      description:
        'Life is short, work somewhere awesome! We’re now hiring testers in Cluj-Napoca.',
      themeColor: '#1800FF'
    },
    styles: jobsStyle
  },
  {
    key: 'jobsDesigner',
    path: '/jobs/designer',
    component: JobsDesigner,
    standalone: true,
    exact: true,
    meta: {
      title: 'Work in Progress: Hiring Junior Designer',
      description:
        'Life is short, work somewhere awesome! We’re now hiring a designer in Cluj-Napoca.',
      themeColor: '#1800FF'
    },
    styles: jobsStyle
  },
  {
    key: 'notfound',
    component: NotFound
  }
];
